export default __webpack_public_path__ + "static/capterra-8e87dd71222a026df1669806afb937ff.png";